import { lazy } from 'react'
import {isProduction} from '@utils'

export const SettingsRoutes = [
  {
    path: '/settings/organization/auth/:auth',
    component: lazy(() => import('@src/modules/setting/components/auth-providers/provider/redirect')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/organization/integrations/:integration/configure/:configure',
    component: lazy(() => import('../views/organization-settings/integration-providers/provider/redirect')),
    meta: {
      configure: true,
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/organization/integrations/:integration',
    component: lazy(() => import('../views/organization-settings/integration-providers/provider/redirect')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/organization',
    component: lazy(() => import('../views/organization-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/checklist',
    component: lazy(() => import('../views/checklist-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/assignment',
    component: lazy(() => import('../views/assignment-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/user',
    component: lazy(() => import('../views/user-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/security',
    component: lazy(() => import('../views/security-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/report',
    component: lazy(() => import('../views/inspection-settings')),
    meta: {
      action: 'call',
      resource: "APP_VIEW_SETTINGS"
    }
  },
  {
    path: '/settings/workspaces',
    component: lazy(() => import('../views/workspaces')),
    meta: {
      action: 'call',
      resource: "NoPermissionCode",
      general: true
    }
  },
  {
    path: '/oauth-callback',
    component: lazy(() => import('../views/organization-settings/integration-providers/component/oauth-callback')),
    meta: {
      action: 'call',
      resource: "NoPermissionCode",
      general: true
    }
  },
  {
    path: '/manage/sections',
    component: lazy(() => import('../views/section-settings/manage-sections')),
    meta: {
      action: 'call',
      resource: "NoPermissionCode",
      general: true
    }
  },
  {
    path: '/section/:id',
    component: lazy(() => import('../views/section-settings/section-details')),
    meta: {
      action: 'call',
      resource: "NoPermissionCode",
      general: true
    }
  },
  {
    path: '/develop/icons',
    component: lazy(() => import('../views/develop/icons')),
    omit: isProduction(),
    meta: {
      action: 'call',
      resource: "NoPermissionCode",
      general: true
    }
  },
  {
    path: '/workspace/settings/plans',
    component: lazy(() => import('../views/pricing')),
    layout: "BlankLayout",
    meta: {
      action: 'call',
      resource: "NoPermissionCode",
      general: true
    }
  }
]

